<template>
  <div class="newProduct">
    <navTab />
    <div class="page_1">
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/TUV.jpg" alt="">
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M-TUV.jpg" alt="">
      <div class="text_content">
        <div class="t1">TEWA TERRON</div>
        <div class="t2">Pure Electric / Range-Extended Electric</div>
        <div class="t3">300+HP</div>
      </div>
    </div>
    <div class="page_2">
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/JETBOAT.jpg" alt="">
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M-JETBOAT.jpg" alt="">
      <div class="text_content">
        <div class="t1">TEWA HydraX</div>
        <div class="t2">Electric</div>
        <div class="t3">200+HP</div>
      </div>
    </div>
    <footerTemp />
  </div>
</template>

<script>
  import navTab from '@/components/navTab.vue'
  import footerTemp from '@/components/footer.vue'
  export default {
    name: 'newProduct',
    components: { navTab, footerTemp },
    data () {
      return {

      }
    },
    mounted () {

    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
  @media (min-width: 769px) {

    .newProduct {
      background-color: #000;

      .page_1 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center;
          margin-top: 10%;
          font-family: "AlibabaPuHuiTi";

          .t1 {
            font-weight: 900;
            font-size: 48.61px;
          }

          .t2 {
            font-size: 20.83px;
            font-weight: 500;
          }

          .t3 {
            font-size: 27.77px;
            font-weight: 900;
            color: #FFA400;
            margin-top: 12px;
          }
        }
      }

      .page_2 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center;
          margin-top: 7%;
          font-family: "AlibabaPuHuiTi";

          .t1 {
            font-weight: 900;
            font-size: 48.61px;
          }

          .t2 {
            font-size: 20.83px;
            font-weight: 500;
          }

          .t3 {
            font-size: 27.77px;
            font-weight: 900;
            color: #FFA400;
            margin-top: 12px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .newProduct {
      background: #000;

      .page_1 {
        width: 100vw;
        position: relative;
        font-family: "AlibabaPuHuiTi";

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center;
          margin-top: 30%;

          .t1 {
            font-size: 16px;
            font-weight: 900;
          }

          .t2 {
            font-size: 10px;
            font-weight: 500;
            margin: 5px 0 10px;
          }

          .t3 {
            font-size: 12px;
            font-weight: 900;
            color: #FFA400;
          }
        }
      }

      .page_2 {
        width: 100vw;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center;
          margin-top: 20%;

          .t1 {
            font-size: 16px;
            font-weight: 900;
          }

          .t2 {
            font-size: 10px;
            font-weight: 500;
            margin: 5px 0 10px;
          }

          .t3 {
            font-size: 12px;
            font-weight: 900;
            color: #FFA400;
          }
        }
      }
    }
  }
</style>